import * as React from 'react';
import { useSelector } from 'react-redux';

import { getSeoLinks } from '../../selectors/seo';
import { SeoLinks } from '../../components/SeoLinks';

export const SeoLinksContainer: React.FC = () => {
  const seoLinks = useSelector(getSeoLinks);

  if (!seoLinks || seoLinks.length === 0) {
    return null;
  }

  return <SeoLinks seoLinks={seoLinks} />;
};
